import { createContext } from 'react';

export interface iNavigationContext {
    setNavigationOpen: () => void;
    setNavigationClosed: () => void;
}

export const NavigationContext = createContext<iNavigationContext>({
    setNavigationOpen: () => {},
    setNavigationClosed: () => {}
});
